import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 739-check
 * @see {GlyphIcon}
 */
const CheckIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M27.37592,9.70459l-14.151,15.97693a.99985.99985,0,0,1-1.47558.02356L4.59711,18.1322a.99992.99992,0,0,1-.05384-1.31128L5.495,15.63123a.99994.99994,0,0,1,1.22808-.26966L12,18,24.79724,7.09863a.99991.99991,0,0,1,1.35553.0542l1.1817,1.18164A1,1,0,0,1,27.37592,9.70459Z";
	}
}

export default CheckIcon;